import { render } from "./InformationsBuilderAndSite.vue?vue&type=template&id=73804bb7"
import script from "./InformationsBuilderAndSite.vue?vue&type=script&lang=js"
export * from "./InformationsBuilderAndSite.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__